import Account from 'Containers/Account';
import DataGatheringLoader from 'Containers/Datagathering/views/Loader';
import Dashboard from 'Containers/Dashboard';
import RequestPhone from 'Containers/PhoneScreen';
import Result from 'Containers/Result';
import Filing from 'Containers/Filing';
import DataGatheringError from 'Containers/Datagathering/views/Error';
import Plans from 'Containers/Plans';
import AccountValidation from 'Containers/Auth/AccountValidation';
import { SignUpStepOne, SignUpStepTwo } from 'Containers/Auth/SignUp';
import EmailValidation from 'Containers/Auth/EmailValidation';
import RecoverPassword from 'Containers/Auth/RecoverPassword';
import DataGatheringValidationAccess from 'Containers/Datagathering/views/ValidationAccess';
import DataGatheringAccessEfirma from 'Containers/Datagathering/views/AccessEfirma';
import PaymentLater from 'Containers/Result/components/PaymentLater';
import Referral from 'Containers/Referral';
import PreviousYearsInfo from 'Containers/PreviousYears/components/PreviousYearsInfo';
import PreviousYears from 'Containers/PreviousYears';
import PreviousYearsWorking from 'Containers/PreviousYears/components/PreviousYearsWorking';
import OnBoarding from 'Containers/Auth/OnBoarding';
import DgOnBoarding from 'Containers/Datagathering/views/DgOnBoarding';
import CalculateResult from 'Containers/PreviousYears/components/CalculateResult';
import PreSalePro from 'Containers/PreSalePro';
import DgLandBot from 'Containers/Datagathering/views/DgLandBot';
import DgEntertainment from 'Containers/Datagathering/views/DGEntertainment';
import DgTypeForm from 'Containers/Datagathering/views/DgTypeForm';
import DgFirstStep from 'Containers/Datagathering/views/DgFirstStep';
import CalculateRfc from 'Containers/Datagathering/views/CalculateRfc';
import DgXmlEntertraiment from 'Containers/Datagathering/views/DGXmlEntertainment';
import RequestPhoneXml from 'Containers/PhoneScreenXml';
import ResultXml from 'Containers/ResultXml';
import FilingXml from 'Containers/FilingXml';
import PaymentLaterXml from 'Containers/ResultXml/components/PaymentLaterXml';
import DataGatheringLoaderXml from 'Containers/Datagathering/views/LoaderXml';
import ClabeInputXml from 'Containers/FilingXml/components/ClabeInputXml';
import ClabeInputFlex from 'Containers/FilingFlex';
import PreviousYearsFilter from 'Containers/PreviousYears/components/PreviousYearsFilter';
import PreviousYearsEfirma from 'Containers/PreviousYears/components/PreviousYearsEfirma';
import PreviousYearsPayLater from 'Containers/PreviousYears/components/PreviousYearsPayLater';
import InstantRefundActive from 'Containers/InstantRefund/components/InstantRefundActive';
import InstantRefundPromote from 'Containers/InstantRefund/components/InstantRefundPromote';
import PreviousYearTypeForm from 'Containers/PreviousYears/components/PreviousYearTypeForm';
import CalculatingLoader from 'Containers/PreviousYears/components/CalculatingLoader';
import NewResultInfo from 'Containers/PreviousYears/components/NewResultInfo';
import QuizMain from 'Containers/Datagathering/views/QuizMain';
import PreFiling from 'Containers/PreFiling';
import ClabeFormPreFiling from 'Containers/PreFiling/components/ClabeFormPreFiling';
import UpsellFiling from 'Containers/UpsellFiling';
import OnlyMgm from 'Containers/UpsellFiling/components/OnlyMgm';
import FlexLiteView from 'Containers/Result/components/FlexLiteView';
import UpsellingPro from 'Containers/Result/components/UpsellingPro';
import PreviousYearsCheckout from 'Containers/PreviousYears/components/PreviousYearsCheckout';
import ResultFilter from 'Containers/Result/components/ResultFilter';
import ResultEfirma from 'Containers/Result/components/ResultEfirma';
import FinSocialAccount from 'Containers/Result/components/FinSocialAccount';
import UpsellingContainer from 'Components/UpsellingContainer';
import { routes } from 'Constants/routes';
import SignIn from '../Auth/SignIn';
import SuccessStep from '../Checkout/SuccessStep';
import DataGatheringAccessRfc from '../Datagathering/views/Access';

// const partner = {
//   SKANDIA: 'skandia',
//   GAIA: 'gaia',
//   PARTNERSHIPSMX: 'partnershipsmx',
// };

export const AUTH_ROUTES = [
  { route: routes.SIGNIN, component: SignIn },
  { route: routes.SIGNUP, component: SignUpStepOne },
  { route: routes.SIGNUP_STEP_TWO, component: SignUpStepTwo },
  // { route: routes.SIGNUP_SKANDIA, component: SignUp, partner: partner.SKANDIA },
  // { route: routes.SIGNUP_GAIA, component: SignUp, partner: partner.GAIA },
  // { route: routes.SIGNUP_PARTNERSHIPSMX, component: SignUp, partner: partner.PARTNERSHIPSMX },
  { route: routes.ACCOUNT_VALIDATION, component: AccountValidation },
  { route: routes.EMAIL_VALIDATION, component: EmailValidation },
  { route: routes.RECOVER, component: RecoverPassword },
];

export const PRIVATE_ROUTES = [
  { route: routes.AUTH_ONBOARDING, component: OnBoarding },
  { route: routes.DASHBOARD, component: Dashboard },
  { route: routes.PLANS, component: Plans },
  { route: routes.ACCOUNT, component: Account, exact: false },
  { route: routes.REFERRAL, component: Referral },
  { route: routes.PERSONAL_PHONE, component: RequestPhone },
  { route: routes.DATAGATHERING_IDENTIFICATION, component: DataGatheringValidationAccess },
  { route: routes.DATAGATHERING_INFO, component: DgOnBoarding },
  { route: routes.DATAGATHERING_IDENTIFICATION_RFC, component: DataGatheringAccessRfc },
  { route: routes.DATAGATHERING_IDENTIFICATION_EFIRMA, component: DataGatheringAccessEfirma },
  { route: routes.DATAGATHERING_HELP, component: DgLandBot },
  { route: routes.DATAGATHERING_LOADER, component: DataGatheringLoader },
  { route: routes.DATAGATHERING_FIRST_STEP, component: DgFirstStep },
  { route: routes.DATAGATHERING_CALCULATE_RFC, component: CalculateRfc },
  { route: routes.DATAGATHERING_ERROR, component: DataGatheringError },
  { route: routes.DATAGATHERING_PRESENTATION, component: DgEntertainment, type: 'presentation' },
  { route: routes.DATAGATHERING_PROFILE, component: DgEntertainment, type: 'profile' },
  { route: routes.DATAGATHERING_EFIRMA_APPLICATION, component: DgEntertainment, type: 'efirma' },
  { route: routes.DATAGATHERING_REFERRAL, component: DgEntertainment, type: 'referral' },
  { route: routes.DATAGATHERING_SAT_ERROR, component: DgEntertainment, type: 'satError' },
  {
    route: routes.DATAGATHERING_ESTIMATED_RESULT,
    component: DgEntertainment,
    type: 'resultEstimated',
  },
  { route: routes.DATAGATHERING_ERROR, component: DataGatheringError },
  { route: routes.DATAGATHERING_TYPEFORM_ESTIMATED_RESULT, component: DgTypeForm },
  { route: routes.DATAGATHERING_QUIZ, component: QuizMain, exact: false },
  { route: routes.RESULT, component: Result },
  { route: routes.FILING, component: Filing },
  { route: routes.CHECKOUT_SUCCESS_STEP, component: SuccessStep },
  { route: routes.CHECKOUT_UPSELLING, component: UpsellingContainer },
  { route: routes.PAYMENT_LATER, component: PaymentLater },
  { route: routes.FLEX_LITE, component: FlexLiteView },
  { route: routes.PREVIOUS_YEARS_INFO, component: PreviousYearsInfo },
  { route: routes.PREVIOUS_YEARS_FILTER, component: PreviousYearsFilter },
  { route: routes.PREVIOUS_YEARS_PROVIDER_ACCOUNT, component: PreviousYearsPayLater },
  { route: routes.PREVIOUS_YEARS_EFIRMA, component: PreviousYearsEfirma },
  { route: routes.PREVIOUS_YEARS_CALCULATE_RESULT, component: CalculateResult },
  { route: routes.PREVIOUS_YEARS, component: PreviousYears },
  { route: routes.PREVIOUS_YEARS_WORKING, component: PreviousYearsWorking },
  { route: routes.PREVIOUS_YEARS_CHECKOUT, component: PreviousYearsCheckout },
  { route: routes.PREVIOUS_YEARS_PRESALE, component: PreSalePro },
  { route: routes.PREVIOUS_YEARS_EFIRMA_TYPE_FORM, component: PreviousYearTypeForm },
  { route: routes.PREVIOUS_YEARS_CALCULATING_LOADER, component: CalculatingLoader },
  { route: routes.PREVIOUS_YEARS_DIFFERENCE, component: NewResultInfo },
  { route: routes.PRE_FILING, component: PreFiling },
  { route: routes.PRE_FILING_CLABE, component: ClabeFormPreFiling },
  { route: routes.FILING_CLABE_FLEX, component: ClabeInputFlex },
  { route: routes.FILING_FLEX, component: FilingXml },
  { route: routes.FILING_INSTANT_REFUND, component: InstantRefundPromote },
  { route: routes.FILING_INSTANT_REFUND_ACTIVE, component: InstantRefundActive },
  { route: routes.FILING_UPSELL, component: UpsellFiling },
  { route: routes.FILING_UPSELL_MGM, component: OnlyMgm },
  { route: routes.UPSELLING_PRO, component: UpsellingPro },
  { route: routes.RESULT_FILTER, component: ResultFilter },
  { route: routes.RESULT_EFIRMA, component: ResultEfirma },
  { route: routes.FIN_SOCIAL_ACCOUNT, component: FinSocialAccount },
  // xml
  {
    route: routes.DATAGATHERING_PRESENTATION_XML,
    component: DgXmlEntertraiment,
    type: 'presentation',
  },
  { route: routes.DATAGATHERING_PROFILE_XML, component: DgXmlEntertraiment, type: 'profile' },
  {
    route: routes.DATAGATHERING_EFIRMA_APPLICATION_XML,
    component: DgXmlEntertraiment,
    type: 'efirma',
  },
  { route: routes.DATAGATHERING_REFERRAL_XML, component: DgXmlEntertraiment, type: 'referral' },
  { route: routes.DATAGATHERING_SAT_ERROR_XML, component: DgXmlEntertraiment, type: 'satError' },
  { route: routes.PERSONAL_PHONE_XML, component: RequestPhoneXml },
  { route: routes.RESULT_XML, component: ResultXml },
  { route: routes.FILING_XML, component: FilingXml },
  { route: routes.FILING_CLABE_XML, component: ClabeInputXml },
  { route: routes.PAYMENT_LATER_XML, component: PaymentLaterXml },
  { route: routes.DATAGATHERING_LOADER_XML, component: DataGatheringLoaderXml },
];
